import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';

import { CHECKBOX_FILTERS } from '../constants';
import { useStyles } from './styles';
import RangeFilters from '../RangeFilters';
import Dialog from '../../Dialog';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';

const AllFiltersDialog = ({ screenWidth, disabled, handleFilterCheck }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const filterGroups = useSelector(state => state.filterbar.filterGroups);
	const checkedFilters = useSelector(state => state.filterbar.checkedFilters);

	const isWidthDownSm = isWidthDown('sm', screenWidth);
	const isWidthUpSm = isWidthUp('sm', screenWidth);

	const handleClose = () => {
		setOpen(false);
	};

	const handleFilterItemClick = (category, filterName) => {
		const currentIndex = checkedFilters[category].indexOf(filterName);
		const newCheckedFilters = [...checkedFilters[category]];

		if (currentIndex === -1) {
			newCheckedFilters.push(filterName);
		} else {
			newCheckedFilters.splice(currentIndex, 1);
		}

		handleFilterCheck(category, newCheckedFilters);
	};

	return (
		<Fragment>
			<div className={classes.buttonContainer}>
				<Button
					color="secondary"
					variant={isWidthUpSm ? 'text' : 'outlined'}
					size="small"
					disabled={disabled}
					onClick={() => setOpen(true)}
					className={classes.button}>
					<Typography>
						{isWidthUpSm
							? t('components.filterBar.allFiltersDialog.allFilters')
							: t('components.filterBar.allFiltersDialog.showFilters')}
					</Typography>
				</Button>
			</div>

			<Dialog
				open={open}
				handleClose={handleClose}
				fullScreen={isWidthDownSm}
				maxWidth={'xl'}
				title={
					isWidthUpSm
						? t('components.filterBar.allFiltersDialog.allFilters')
						: t('components.filterBar.allFiltersDialog.filters')
				}
				content={
					<Fragment>
						<Typography variant="subtitle1">{t('components.filterBar.designAttributes')}</Typography>

						<RangeFilters />

						<GridList cellHeight={'auto'} cols={5} className={classes.gridList}>
							{Object.entries(filterGroups).map(([category, filters]) => (
								<GridListTile key={category + '-grid-list-tile'} className={classes.gridListTile}>
									<Typography variant="subtitle1">
										{CHECKBOX_FILTERS.find(filterGroup => filterGroup.name === category).label}
									</Typography>

									<List>
										{filters.map(filter => (
											<ListItem
												key={filter.name}
												button
												onClick={() => handleFilterItemClick(category, filter.name)}
												className={classes.listItem}
												disabled={filters.length < 2}>
												<ListItemIcon className={classes.listItemIcon}>
													<Checkbox
														color="primary"
														checked={filters.length < 2 || checkedFilters[category].indexOf(filter.name) !== -1}
														tabIndex={-1}
														disableRipple
														inputProps={{
															'aria-labelledby': filter.name + '_li_id'
														}}
													/>
												</ListItemIcon>

												<ListItemText id={filter.name + '_li_id'} primary={<Typography>{filter.label}</Typography>} />
											</ListItem>
										))}
									</List>
								</GridListTile>
							))}
						</GridList>
					</Fragment>
				}
			/>
		</Fragment>
	);
};

AllFiltersDialog.propTypes = {
	screenWidth: PropTypes.string.isRequired,
	disabled: PropTypes.bool.isRequired,
	handleFilterCheck: PropTypes.func.isRequired
};

export default AllFiltersDialog;
